import { HARDCODEURL } from "../../Model/Network/Api/config";
import axios from "../../Model/Network/Config/Axios";

class Model {

	changePassword = (data, cb) => {
		axios.patch(`${HARDCODEURL}/auth/reset`, data)
			.then(res => cb(null, res.data))
			.catch(err => cb(err));
	}

}

export default Model;
